import 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Response } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AdalService } from '../service';
import { Constants } from '../shared/constants';

@Injectable()
export class AzureService {
	errormsg: string;
	// url = 'http://localhost:65090/api/values';
	private url = Constants.devServerEndpoint + 'api/values';
	private token;
	private headers;
	constructor(
		private http: HttpClient,
		private adalService: AdalService) {
		this.token = this.adalService.accessToken;
		this.headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

		// this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		// let jwt = this.adalService.accessToken;
		// this.headers.append('Authorization', 'Bearer ' + jwt);
		// this.options = new RequestOptions({ headers: this.headers });
	}

	getResponse(): Observable<any> {
		return this.http.get(this.url, { headers: this.headers })
			.pipe(
				map((res) => {
					return res;
				}),
				catchError(this.handleError)
			);
	}

	private handleError(error: any) {
		console.error('server error:', error);
		if (error) {
			let errMessage = '';
			try {
				errMessage = error.json().error;
			} catch (err) {
				errMessage = error.statusText;
			}
			return observableThrowError(errMessage);
		}
		return observableThrowError(error || 'server error');
	}
}
